export default __webpack_public_path__ + "static/media/terms.a48fb500.md";